import React from 'react'
import { Breadcrumb } from 'antd'
import { Link, useLocation } from 'react-router-dom'

export const Breadcrumbs: React.FC = () => {
  const location = useLocation()
  const pathSnippets = location.pathname.split('/').filter((i) => i)

  const extraBreadcrumbItems = pathSnippets.map((snippet, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
    return {
      key: url,
      title: <Link to={url}>{snippet}</Link>,
    }
  })

  const breadcrumbItems = [
    {
      key: 'home',
      title: <Link to="/">Home</Link>,
    },
    ...extraBreadcrumbItems,
  ]

  return <Breadcrumb style={{ margin: '16px 0' }} items={breadcrumbItems} />
}
